// Inicialización automática del comercio desde token
import { getComercioId, getComercioNombre } from '../config/comercio.js';
import { getComercioData } from '../api/database.js';

// Estado global del comercio
let comercioState = {
  id: null,
  nombre: null,
  initialized: false
};

// Función para inicializar el comercio desde token
export const inicializarComercio = async () => {
  try {
    let comercioId = null;
    let comercioNombre = 'Comercio';
    let fantasia = 'Comercio';
    let tokenVencimiento = null;
    
    // Obtener token de localStorage (manejado centralmente por App.jsx)
    const token = localStorage.getItem('comercio_token') || localStorage.getItem('token');
    console.log('🔍 [COMERCIO_INIT] Token obtenido:', token ? 'SÍ' : 'NO');
    
    // Obtener datos completos del comercio desde la API de perfil
    tokenVencimiento = null;
    
    console.log('🔍 [COMERCIO_INIT] Token para perfil:', token);
    
    if (token) {
      try {
        console.log('🔍 [COMERCIO_INIT] Llamando API de perfil...');
        const response = await fetch(`https://www.sinfilas.com.ar/sf3/ventas/api/comercios_perfil_cargar.php?token=${token}&_t=${Date.now()}`);
        console.log('🔍 [COMERCIO_INIT] Respuesta perfil:', response.status);
        
        if (response.ok) {
          const perfilData = await response.json();
          console.log('🔍 [COMERCIO_INIT] Datos perfil:', perfilData);
          
          if (perfilData.success && perfilData.data) {
            comercioId = perfilData.data.id;
            comercioNombre = perfilData.data.empresa || comercioNombre;
            fantasia = perfilData.data.fantasia || comercioNombre;
            tokenVencimiento = perfilData.data.token_vencimiento || null;
            console.log('🔍 [COMERCIO_INIT] Comercio ID extraído:', comercioId);
            console.log('🔍 [COMERCIO_INIT] Nombre extraído:', comercioNombre);
            console.log('🔍 [COMERCIO_INIT] Fantasia extraída:', fantasia);
            console.log('🔍 [COMERCIO_INIT] Vencimiento extraído:', tokenVencimiento);
            
            // Cálculo directo para debug
            if (tokenVencimiento) {
              const fechaVencimiento = new Date(tokenVencimiento);
              const fechaActual = new Date();
              fechaActual.setHours(0, 0, 0, 0);
              fechaVencimiento.setHours(0, 0, 0, 0);
              const diferencia = fechaVencimiento.getTime() - fechaActual.getTime();
              const diasRestantes = Math.ceil(diferencia / (1000 * 60 * 60 * 24));
              console.log('🔍 [COMERCIO_INIT] Cálculo directo - Días restantes:', diasRestantes);
            }
          }
        }
      } catch (error) {
        console.error('Error obteniendo datos del perfil:', error);
      }
    }
    
    console.log('🔍 [COMERCIO_INIT] Valores finales:');
    console.log('🔍 [COMERCIO_INIT] comercioId:', comercioId);
    console.log('🔍 [COMERCIO_INIT] comercioNombre:', comercioNombre);
    console.log('🔍 [COMERCIO_INIT] fantasia:', fantasia);
    console.log('🔍 [COMERCIO_INIT] tokenVencimiento:', tokenVencimiento);
    
    comercioState = {
      id: comercioId,
      nombre: comercioNombre,
      fantasia: fantasia,
      token_vencimiento: tokenVencimiento,
      initialized: true
    };
    
    console.log('🔍 [COMERCIO_INIT] comercioState actualizado:', comercioState);
    
    
    return { success: true, comercio: comercioState };
  } catch (error) {
    console.error('❌ [COMERCIO] Error:', error);
    return { success: false, error: error.message };
  }
};

// Función para obtener el estado del comercio
export const getComercioState = () => ({ ...comercioState });

// Función para verificar si está inicializado
export const isComercioInicializado = () => comercioState.initialized;

// Función para obtener el ID del comercio
export const getComercioIdActual = () => comercioState.id;

// Función para obtener el nombre del comercio
export const getComercioNombreActual = () => comercioState.nombre;


// Función para obtener el token guardado
export const getTokenFromStorage = () => {
  return localStorage.getItem('comercio_token');
};

// Inicialización automática
if (typeof window !== 'undefined') {
  // Inicializar inmediatamente si ya hay un token en localStorage
  const token = localStorage.getItem('comercio_token') || localStorage.getItem('token');
  if (token) {
    inicializarComercio();
  }
  
  // También inicializar cuando se carga la página
  window.addEventListener('load', () => {
    inicializarComercio();
  });
}

export default {
  inicializarComercio,
  getComercioState,
  isComercioInicializado,
  getComercioIdActual,
  getComercioNombreActual
};